import "./ChildComponentUI.scss";
import React, { useEffect, useState } from "react";
import Chat from "../../../components/UI/Chat/Chat";
import {
  classSelector,
  SVG,
  selectIcon,
  textColorSelector,
} from "../../../components/UI/selector";
import {
  CheckAccess,
  checkCount,
  CheckValue,
  getAvailableUser,
  getOndemandAvailableUser,
  getTime,
} from "../../../services/CommonFunction";
import { imageError } from "../../../services/subscriberService";
import {
  changeVolume,
  getAudioVolume,
  getDefaultValue,
  InputRange,
} from "../../../components/UI/InputRange/InputRange";
import Pagination from "../Pagination/Pagination";
import ToolTips from "../../../components/UI/ToolTips/ToolTips";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { setStartStreamForRecording } from "../SocketFun";
import HideUnhideDiv from "../HideUnhideDiv/HideUnhideDiv";
import OutsideAlerter from "../../../components/UI/OutsideAlerter/OutsideAlerter";

export const Logo = ({ workoutData, ...props }) => (
  <div className="logoBox">
    <img
      className="logoImage"
      alt="placeholder"
      src={workoutData.logo_thumb}
      onError={imageError}
    />
  </div>
);

export const CenterCoachProfile = ({ profile_pic_thumb }) => (
  <div className="coach_div">
    <img src={profile_pic_thumb} />
  </div>
);

export const StopWatch = ({ duration, ...props }) => {
  const { hour, minutes, second } = getTime(duration);
  return (
    <div className="stopWatch">
      <span className="title">Starts in :</span>
      <div className="time">
        <TimeUI text="Min" time={minutes} />
        <TimeUI text="Sec" time={second} />
      </div>
    </div>
  );
};

const TimeUI = ({ text, time, ...props }) => {
  const themeColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--theme-color");
  return (
    <div className="timeUI">
      <span className={`number ${themeColor === "light" ? "light" : "dark"}`}>
        {time}
      </span>
    </div>
  );
};

export const PinUser = ({ allUsers, userPin, tagUsers }) => {
  const user = tagUsers
    .filter((el) => el.showStream)
    .map((data, index) => {
      const el = { ...allUsers[data.user_id] };
      return <PinUserUI key={el.user_id} {...el} userPin={userPin} />;
    });
  const noState = (
    <div className="pin-noState">
      <div className="userPin">
        <SVG src={selectIcon("pinIcon")} />
      </div>
      <p>Pin your friends to see them during the workout</p>
    </div>
  );
  return (
    <HideUnhideDiv
      clasType={`left`}
      clas={`pinUser${user.length ? "" : " noState"}`}
    >
      {user.length ? user : noState}
    </HideUnhideDiv>
  );
};

const PinUserUI = ({ first_name, user_id, userPin, profile_pic_thumb, me }) => (
  <div className={`userUi box-layer1${me ? " me" : ""}`}>
    <div className="userDetail">
      <div className="userPicture">
        <img
          src={
            CheckValue(profile_pic_thumb)
              ? profile_pic_thumb
              : selectIcon("userDummy")
          }
          alt="userImage"
          onError={imageError.bind(this)}
        />
      </div>
      <span className="userName">{me ? "Me" : first_name}</span>
      {/* <ToolTips position="top" overflow={true} showTooltip={true} message={me?'Anmol Garg abc hagsyh hd h cxbhsdc shgd csbd chd csdc s sd hbs csd shj ':first_name}>
            </ToolTips> */}
    </div>
    <div className="userPin active" onClick={() => userPin(user_id)}>
      <SVG src={selectIcon("pinIcon")} />
    </div>
  </div>
);

const checkLastPage = (user, show) => {
  if (user.length <= show) {
    return 1;
  }
  let page = user.length / show;
  const remaing = user.length % show;
  if (remaing > 0) {
    page += 1;
  }
  return page;
};

const caloriesASC = (a, b) => {
  let textA = a["calories_burnt"] || 0;
  let textB = b["calories_burnt"] || 0;
  return textA > textB ? -1 : textA < textB ? 1 : 0;
};
const caloriesDES = (a, b) => {
  var textA = a["calories_burnt"] || 0;
  var textB = b["calories_burnt"] || 0;
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

const SortData = (a, b) => {
  var textA = a["me"];
  var textB = b["me"];
  return textA === textB ? 0 : textA ? -1 : 1;
};

const sortDataASC = (a, b) => {
  var textA = a["first_name"].toLowerCase();
  var textB = b["first_name"].toLowerCase();
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

const participantSort = (a, b) => {
  var textA = a["stream"];
  var textB = b["stream"];
  return textA === textB ? 0 : textA ? -1 : 1;
};

export const checkLimit = (arr, limit, page, zoom) => {
  let temp = [...arr];
  // temp.sort(sortDataASC)
  // temp.sort(participantSort)
  temp.sort(SortData);
  let min = limit * page;
  let max = limit + limit * page;
  const sliceArr = temp.slice(min, max);
  temp.splice(limit * page, limit);
  if (CheckValue(zoom)) {
    return zoom.zoomRank(temp, min, max, sliceArr);
    // sliceArr.forEach(el => {
    //     // if (!CheckValue(el.muteSubscriber)) {
    //     //     zoom.subscribeVolumeIndicator(el.presentAttendeeId);
    //     // }
    //     if (CheckValue(el.userId) && !el.stream && el.isVideoStarted) {
    //         zoom.stopAttendeeVideo(el.userId);
    //     } else if (CheckValue(el.userId) && el.stream && !el.isVideoStarted) {
    //         zoom.startAttendeeVideo(el.userId, index)
    //     }else if (CheckValue(el.userId) && el.stream && el.isVideoStarted){

    //     }
    //     index++;
    // });
    // temp.forEach(el => {
    //     // if (CheckValue(el.muteSubscriber)) {
    //     //     zoom.unsubscribeVolumeIndicator(el.presentAttendeeId);
    //     // }
    //     if (CheckValue(el.userId) && el.isVideoStarted) {
    //         zoom.stopAttendeeVideo(el.userId)
    //     }
    // });
  }
  return sliceArr;
};

export const checkOngoingLimit = (arr) => {
  // temp.sort(sortDataASC)
  // temp.sort(participantSort)
  // return arr.sort(SortData);
  // return arr.sort(caloriesASC);
  let temp = [...arr];
  temp.sort(SortData);
  // return [...arr,...arr,...arr,...arr,...arr];
  return arr;
};

const BoardContainerDiv = ({
  chatRef,
  memberData,
  socket,
  allUserLength,
  allUsersArr,
  workoutData,
  gymData,
  staffsInActivity,
  coachData,
  userActivityData,
  activeSpeakerText,
  callback = Function(),
  ...props
}) => {
  const count = CheckValue(chatRef) ? checkCount(chatRef) : 0;
  const [chatSelect, setChatSelect] = useState(false);
  return (
    <HideUnhideDiv
      callback={callback}
      clasType={`${chatSelect ? "chat" : ""}right`}
      clas={`boardContainers${chatSelect ? " chat" : ""}`}
    >
      <div className="tab">
        <div
          className="memberIcon1"
          onClick={() => (CheckValue(chatRef) ? setChatSelect(false) : null)}
        >
          <SVG src={selectIcon("memberIcon1")} />
          <span>{allUserLength}</span>
        </div>
        {CheckValue(chatRef) ? (
          <div className="chatIcon1 active" onClick={() => setChatSelect(true)}>
            <SVG src={selectIcon("chatIcon1")} />
            {!chatSelect && count > 0 ? (
              <div className="messageCount">
                <p>{count > 9 ? "9+" : count}</p>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
      {CheckValue(chatRef) ? (
        <Chat
          ref={chatRef}
          workoutData={workoutData}
          gymName={gymData.name}
          staffsInActivity={staffsInActivity}
          coachData={coachData}
          memberData={memberData}
          userActivityData={userActivityData}
          userId={userActivityData.user_id}
          userSessionId={userActivityData.user_activity_session_id}
          chatUxToggle={chatSelect}
          socket={socket}
        />
      ) : null}
      <div
        id="member_view_div"
        className={`member_view_div${chatSelect ? " hide" : ""}`}
      >
        {props.children}
      </div>
    </HideUnhideDiv>
  );
};

export const BoardContainerWaitingRoom = ({
  allUsers,
  zoom,
  userPin,
  userActivityData,
  ...props
}) => {
  const { allUsersArr, allUserLength } = getAvailableUser(allUsers, "all");
  const [page, setPage] = useState(1);
  const limit = 4;
  const user = checkLimit(allUsersArr, limit, page - 1, zoom).map((el) => {
    return (
      <UserUi
        ondemand={false}
        key={el.user_id}
        {...el}
        userPin={userPin}
        showPin={true}
      />
    );
  });

  const hideUnhideCallback = (status) => {
    zoom.stopRenderingParticipantsVideos(status);
  };

  const paginationCallback = (newPage) => {
    if (page !== newPage) {
      zoom.stopVideosAndClearCanvas();
    }
    setPage(newPage);
  };

  return (
    <BoardContainerDiv
      {...props}
      callback={hideUnhideCallback}
      allUsersArr={allUsersArr}
      userActivityData={userActivityData}
      allUserLength={allUserLength}
      memberData={allUsers[userActivityData.user_id]}
    >
      <div id="user_container" className="user_container">
        <canvas
          id="participants-canvas"
          className="video-canvas"
          height={522}
          width={219}
        ></canvas>
        {user}
      </div>
      <div className="list_button_container">
        <Pagination
          limit={limit}
          currentPage={page}
          setPage={paginationCallback}
          userArrLength={allUserLength}
        />
      </div>
      {props.children}
    </BoardContainerDiv>
  );
};

export const BoardContainerOngoingRoom = ({
  required,
  allUsers,
  zoom,
  userPin,
  userActivityData,
  activeSpeakerText,
  ...props
}) => {
  const { allUsersArr, allUserLength } = getAvailableUser(allUsers, "all");
  const showPin = allUsersArr.filter((el) => el.showStream).length < 5;
  const user = allUsersArr.map((el, index) => {
    return (
      <MemberUi
        key={el.user_id}
        showPin={true}
        {...el}
        ondemand={false}
        required={required}
        rank={index + 1}
        userPin={userPin}
        calories={el.calories_burnt}
      />
    );
  });
  return (
    <BoardContainerDiv
      {...props}
      allUsersArr={allUsersArr}
      userActivityData={userActivityData}
      allUserLength={allUserLength}
      memberData={allUsers[userActivityData.user_id]}
      activeSpeakerText={activeSpeakerText}
    >
      <div className="user_container">{user}</div>
      {props.children}
    </BoardContainerDiv>
  );
};
export const BoardContainerOndemandRoom = ({
  totalMembers,
  required,
  allUsers,
  userPin,
  userActivityData,
  ondemand,
  ...props
}) => {
  // console.log('allUsers',allUsers);
  const { allUsersArr, allUserLength } = getOndemandAvailableUser(
    allUsers,
    "all"
  );
  // const showPin = allUsersArr.filter(el => el.showStream).length < 5;
  const user = allUsersArr.map((el, index) => {
    return (
      <MemberUi
        key={el.user_id}
        {...el}
        ondemand={ondemand}
        showPin={CheckAccess("userStream") && el.video_stream}
        required={required}
        rank={el.rank}
        userPin={userPin}
        calories={el.calories_burnt}
      />
    );
  });
  return (
    <BoardContainerDiv
      {...props}
      allUsersArr={allUsersArr}
      userActivityData={userActivityData}
      allUserLength={totalMembers}
    >
      <div className="user_container">{user}</div>
      {props.children}
    </BoardContainerDiv>
  );
};

export const Footer = ({
  statsClick,
  required,
  zoom,
  zoomData,
  selfData,
  value,
  id,
  ...props
}) => {
  const currentHeartRate = selfData.heartrate
    ? Math.round(selfData.heartrate)
    : 0;
  const currentHeartRatePer = selfData.max_heart_rate_percent
    ? Math.round(selfData.max_heart_rate_percent)
    : 0;
  const checkClas = `statsBox_container`;
  // const checkClas = `statsBox_container${required.isHeartRateRequired && required.isLeaderBoardRequired ?
  //     ' showHearteRate' : required.isHeartRateRequired && !required.isLeaderBoardRequired ? ' showHearteRate' : ' hideHeartAndRank'}`;
  return (
    <HideUnhideDiv clasType="ftr" clas={checkClas}>
      {/* <div className={`${checkClas} ${'ftr'} overflow_hidden`} >
                <SVG className='background_stats' src={selectIcon('backgroundStats1')} />
            </div> */}
      {/* <SVG className='background_stats' src={selectIcon('backgroundStats1')} /> */}
      <div className="statsBox">
        {/* {this.state.isHeartRateRequired ? */}
        <React.Fragment>
          {required.isHeartRateRequired ? (
            <div className={`stats_heartrate`}>
              <SVG
                className={`stats_heart ${classSelector(currentHeartRatePer)}`}
                src={selectIcon("heartIcon")}
              />
              <div
                className={`stats_number ${classSelector(currentHeartRatePer)}`}
              >
                <span>{currentHeartRate || "-"}</span> <p>bpm</p>
              </div>
            </div>
          ) : null}
          <Icon
            disable={zoomData && !zoomData.sessionStatus}
            status={zoom && !zoom.getLocalMuteStatus()}
            icon="audio"
            onClick={(e) => statsClick("audio")}
          />
          <Icon
            disable={zoomData && !zoomData.sessionStatus}
            status={zoom && zoom.getLocalVideoStatus()}
            icon="video"
            onClick={(e) => statsClick("camera")}
          />
          {/* <Volume icon="volume" value={value} id={id}  /> */}
        </React.Fragment>
        {/* :
                null
            } */}
      </div>
    </HideUnhideDiv>
  );
};

const MoreOption = ({ leaveMeeting, ondemand, ...props }) => {
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [left, setLeft] = useState(0);
  const [top, seTop] = useState(0);
  const [opacity, setOpacity] = useState(0);
  const more_icon = document.getElementById("more_icon");
  useEffect(() => {
    setLeft(positionX - (width - 51));
    seTop(positionY - (height + 15));
  }, [positionX, positionY, width, height]);
  const { x, y } = more_icon.getBoundingClientRect();
  if (positionX !== x) {
    setPositionX(x);
  }
  if (positionY !== y) {
    setPositionY(y);
  }
  const moreOption = document.getElementById("moreOption");
  if (CheckValue(moreOption) && !opacity) {
    const { width, height } = moreOption.getBoundingClientRect();
    setWidth(width);
    setHeight(height);
    setOpacity(1);
  }
  return (
    <div
      id="moreOption"
      className="moreOption"
      style={{ top: top + "px", left: left + "px", opacity: opacity }}
    >
      <div className="moreOption_inner">
        {/* <div className='moreOption_inner_row' onClick={setStopCoachVideo}>
                    <div className='moreOption_inner_row_svg'>
                        <SVG src={selectIcon(stopCoachVideo ? 'startVideoIcon' : 'stopVideoIcon')}/>
                    </div>
                    <span className='moreOption_inner_row_text'>{stopCoachVideo ? 'Start' : 'Stop'} coach video</span>
                </div> */}
        <div className="moreOption_inner_row" onClick={leaveMeeting}>
          <div className="moreOption_inner_row_svg">
            <SVG src={selectIcon("crossIcon")} style={{ padding: 4 + "px" }} />
          </div>
          <span className="moreOption_inner_row_text">
            {ondemand ? "End Class" : "Leave Class"}
          </span>
        </div>
        {/* <div className='moreOption_inner_row'>
                    <div className='moreOption_inner_row_svg'>
                        <SVG src={selectIcon('stopVideoIcon')} />
                    </div>
                    <span className='moreOption_inner_row_text'>Leave class</span>
                </div>
                <div className='moreOption_inner_row'>
                    <div className='moreOption_inner_row_svg'>
                        <SVG src={selectIcon('stopVideoIcon')} />
                    </div>
                    <span className='moreOption_inner_row_text'>{`Help & Support`}</span>
                </div> */}
      </div>
    </div>
  );
};

export const FooterOngoing = ({
  ondemand,
  stopCoachVideo,
  statsClick,
  memberVideos,
  required,
  selfData,
  rank,
  value,
  calories_burnt,
  id,
  low_latency_mode,
  zoom,
  mute_participants_by_default,
  leaveMeeting,
  activeSpeakerText,
  ...props
}) => {
  const [showMore, setShowMore] = useState(false);
  const maxHeartRatePercent = selfData.maxHeartRatePercent
    ? Math.round(selfData.maxHeartRatePercent)
    : 0;
  const maxHeartRate = selfData.maxheartrate
    ? Math.round(selfData.maxheartrate)
    : 0;
  const currentHeartRate = selfData.heartrate
    ? Math.round(selfData.heartrate)
    : 0;
  const currentHeartRatePer = selfData.max_heart_rate_percent
    ? Math.round(selfData.max_heart_rate_percent)
    : 0;
  // const checkClas = `statsBox_container${required.isHeartRateRequired && required.isLeaderBoardRequired ?
  //     ' showHeartAndRank' : required.isHeartRateRequired && !required.isLeaderBoardRequired ? ' showHeartNotRank' : ' hideHeartAndRank'}`;
  const checkClas = `statsBox_container`;
  const moreOption = showMore ? (
    <OutsideAlerter
      clickOutSide={() => {
        setTimeout(() => {
          setShowMore(false);
        }, 200);
      }}
    >
      <MoreOption leaveMeeting={leaveMeeting} ondemand={ondemand} />
    </OutsideAlerter>
  ) : null;
  const status = low_latency_mode && !mute_participants_by_default;
  return (
    <React.Fragment>
      {moreOption}
      <HideUnhideDiv clasType="ftr" clas={checkClas}>
        {/* <div className={`${checkClas} ${'ftr'} overflow_hidden`} >
                    <SVG className='background_stats' src={selectIcon('backgroundStats1')} />
                </div> */}
        {activeSpeakerText}
        <div className="statsBox">
          {/* {this.state.isHeartRateRequired ? */}
          <React.Fragment>
            {/* required.isHeartRateRequired ?
                            <div className={`stats_heartrate_ongoing ${classSelector(currentHeartRatePer)}`}>
                                <SVG className={`stats_heart ${classSelector(maxHeartRatePercent)}`}
                                     src={selectIcon('heartIcon')}/>
                                <div className={`stats_number ${classSelector(maxHeartRatePercent)}`}>
                                    <span>{maxHeartRate || '---'}</span> Max
                                </div>
                                <div className={`stats_number ${classSelector(currentHeartRatePer)}`}>
                                    <span>{currentHeartRate || '---'}</span> Now
                                </div>
                            </div> : null}
                        {required.isHeartRateRequired ?
                            <Calories calories={selfData.calories_burnt ? Math.round(selfData.calories_burnt) : 0}/>
                            : null */}
            {required.isLeaderBoardRequired ? (
              <div className="myRank">
                <SVG className={`rank_icon`} src={selectIcon("rank_icon")} />
                <span className="rank_number">
                  {CheckValue(selfData.calories_burnt) ? rank : "---"}
                </span>
              </div>
            ) : null}
            {low_latency_mode ? (
              <Icon
                disable={false}
                status={zoom && zoom.getLocalVideoStatus()}
                icon="video"
                onClick={(e) => zoom.enableDisableAudioCamera("camera")}
              />
            ) : !ondemand || CheckAccess("userStream") ? (
              <Icon
                disable={!CheckValue(memberVideos)}
                status={
                  memberVideos && memberVideos.getStreamData.isCameraEnabled
                }
                icon="video"
                onClick={(e) => memberVideos.startStopStream()}
              />
            ) : null}
            {status ? (
              <Icon
                disable={false}
                status={zoom && !zoom.getLocalMuteStatus()}
                icon="audio"
                onClick={(e) => zoom.enableDisableAudioCamera("audio")}
              />
            ) : null}
            {ondemand || !low_latency_mode ? (
              <Volume icon="volume" value={value} id={id} />
            ) : null}

            <MoreIcon
              status={showMore}
              onClick={() => (!showMore ? setShowMore(!showMore) : null)}
            />
          </React.Fragment>
          {/* :
                    null
                } */}
        </div>
      </HideUnhideDiv>
    </React.Fragment>
  );
};

const Icon = ({ status, icon, onClick, disable, image }) => {
  // const icons = `${status ? '' : 'no'}${icon}`;
  // +'?v='+randomString(4)
  const newIcon = `${status ? "" : "no"}${icon}`;
  return (
    <div
      className={`stats_icon ${disable ? " disable" : status ? " active" : ""}`}
      onClick={() => (!disable ? onClick(!status) : null)}
    >
      {image ? (
        <img src={selectIcon(newIcon + "Png")} />
      ) : (
        <SVG className={icon} src={selectIcon(newIcon)} />
      )}
    </div>
  );
};

const MoreIcon = ({ status, onClick }) => (
  <div
    id="more_icon"
    className={`stats_icon ${status ? " active" : ""}`}
    onClick={onClick}
  >
    <SVG className="moreIcon" src={selectIcon(`moreIcon`)} />
  </div>
);

const Volume = ({ icon, id }) => {
  const [mute, setMute] = useState(getDefaultValue().status);
  const checkMute = getAudioVolume(id);
  return (
    <div className={`stats_icon_volume${checkMute ? "" : " active"}`}>
      <InputRange max={100} min={0} step={1} id={id} setMute={setMute} />
      <div className="stats_icon_volume_iconDiv">
        <SVG
          className={icon}
          src={selectIcon(`${checkMute ? "no" : ""}${icon}`)}
          onClick={() => {
            changeVolume(checkMute ? 100 : 0, id, true, setMute);
          }}
        />
      </div>
    </div>
  );
};

export const CurrentUser = ({ speaker, allUsers }) => {
  let thumb = null;
  let name = null;
  if (allUsers.hasOwnProperty(speaker.user_id) && speaker.score > 0.2) {
    // if (allUsers.hasOwnProperty(speaker.user_id)) {
    thumb =
      allUsers[speaker.user_id].profile_pic_thumb || selectIcon("userDummy");
    name = allUsers[speaker.user_id].me
      ? `You're speaking...`
      : `${allUsers[speaker.user_id].first_name || ""} is speaking...`;
  }
  return (
    <React.Fragment>
      n
      {CheckValue(name) ? (
        <div className="speaking_div">
          <div className="speaking_background"></div>
          <div className="speaking_left"></div>
          <div className="speaking">{name}</div>
          <div className="speaking_right"></div>
        </div>
      ) : null}
      {/* {CheckValue(name)?<div className='current_user'>
                <img src={thumb} alt="userImage" onError={imageError.bind(this)} />
                <span className='name'>{name}</span>
            </div>:null} */}
    </React.Fragment>
  );
};

const playerState = (e, setStartStream, isVideoStarted) => {
  if (e.target.readyState === 4 && !isVideoStarted) {
    setStartStream(true);
  }
};

export const UserUi = ({
  me,
  ondemand,
  totalSeconds,
  setStartStream,
  first_name,
  user_id,
  profile_pic_thumb,
  isVideoStarted,
  userPin,
  showPin,
  video_stream,
  ant_media_recording,
  showStream,
  showCalories,
  calories_burnt,
  ...props
}) => {
  const themeColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--theme-color");
  document.documentElement.style.setProperty(
    "--dynamic-variable",
    themeColor === "light" ? "#505050" : "#000000"
  );
  return (
    <div
      id={user_id}
      className={`user_view${me ? " me" : ""}${
        isVideoStarted ? "" : " noVideo"
      }`}
    >
      <div className="view">
        {showPin && (ondemand ? true : !me) ? (
          <div
            className={`userPin${showStream ? " active" : ""}`}
            onClick={() => userPin(user_id)}
          >
            <SVG src={selectIcon("pinIcon")} />
          </div>
        ) : null}
        {ondemand ? (
          <div className="memberVideo">
            {/* <canvas style={{ opacity: showVideo ? 1 : 0, display: showVideo ? 'inherit' : 'none' }} id={user_id}></canvas> */}
            <video
              className={`video_img${isVideoStarted ? " show" : ""}`}
              id={user_id}
              muted
              src={ant_media_recording}
              onPlay={(e) => {
                playerState(e, setStartStream, isVideoStarted);
              }}
              onPause={(e) => {
                const duration = e.target.duration;
                const currentTime = e.target.currentTime;
                if (duration === currentTime) {
                  setStartStream(false);
                }
              }}
              // onStop={e => console.log(e.target.readyState, 'stop')}
              onLoadedMetadata={(e) => console.log(e.target.readyState)}
              onLoadStart={(e) => console.log(e.target.readyState)}
              onLoad={(e) => console.log(e.target.readyState)}
              onLoadedData={(e) =>
                console.log(e.target.readyState, "onLoadedData")
              }
              onCanPlay={(e) => console.log(e.target.readyState, "onCanPlay")}
              onCanPlayThrough={(e) => {
                const duration = e.target.duration;
                console.log(
                  e.target.readyState,
                  "onCanPlayThrough",
                  duration,
                  totalSeconds
                );
                // if (duration > totalSeconds) {
                console.log("enter");
                e.target.play();
                // e.target.currentTime = totalSeconds;
                playerState(e, setStartStream, isVideoStarted);
                // }
              }}
            ></video>
            <img
              className={`video_img${isVideoStarted ? "" : " show"}`}
              src={
                CheckValue(profile_pic_thumb)
                  ? profile_pic_thumb
                  : selectIcon("userDummy")
              }
              alt="userImage"
              onError={imageError.bind(this)}
            />
          </div>
        ) : (
          <div className="memberVideo">
            {/* <canvas style={{ opacity: showVideo ? 1 : 0, display: showVideo ? 'inherit' : 'none' }} id={user_id}></canvas> */}
            <video
              className={`video_img${isVideoStarted ? " show" : ""}`}
              id={user_id + "_video"}
              autoPlay
              muted
            ></video>
            <img
              className={`video_img${isVideoStarted ? "" : " show"}`}
              src={
                CheckValue(profile_pic_thumb)
                  ? profile_pic_thumb
                  : selectIcon("userDummy")
              }
              alt="userImage"
              onError={imageError.bind(this)}
            />
          </div>
        )}
        <div className="name_calories">
          <ToolTips
            overflow={true}
            showTooltip={true}
            position={showPin ? "left" : "right"}
            className="name"
            message={me ? "Me" : first_name}
          >
            {me ? "Me" : first_name}
          </ToolTips>
          {CheckValue(showCalories) && showCalories ? (
            <Calories calories={calories_burnt} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export const UserUiZoomPinnedView = ({
  me,
  setStartStream,
  first_name,
  user_id,
  profile_pic_thumb,
  isVideoStarted,
  ...props
}) => {
  const themeColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--theme-color");
  document.documentElement.style.setProperty(
    "--dynamic-variable",
    themeColor === "light" ? "#505050" : "#000000"
  );
  return (
    <div
      id={user_id}
      className={
        me
          ? `myStreamVIdeo${isVideoStarted ? " video" : " noVideo"}`
          : `user_view${isVideoStarted ? "" : " noVideo"}`
      }
    >
      {me ? (
        <div className="name_calories">
          <span>
            {isVideoStarted ? (
              "Me"
            ) : (
              <React.Fragment>
                Click on
                <span className="icon_div">
                  <SVG className="scanIcon" src={selectIcon("video")} />
                </span>
                below to see your video here
              </React.Fragment>
            )}
          </span>
        </div>
      ) : (
        <div className="view">
          {
            <div className="memberVideo">
              {/* <canvas style={{ opacity: showVideo ? 1 : 0, display: showVideo ? 'inherit' : 'none' }} id={user_id}></canvas> */}
              <video
                className={`video_img${isVideoStarted ? " show" : ""}`}
                id={user_id}
                autoPlay
                muted
              ></video>
              <img
                className={`video_img${isVideoStarted ? "" : " show"}`}
                src={
                  CheckValue(profile_pic_thumb)
                    ? profile_pic_thumb
                    : selectIcon("userDummy")
                }
                alt="userImage"
                onError={imageError.bind(this)}
              />
            </div>
          }
          <div className="name_calories">
            <ToolTips
              overflow={true}
              showTooltip={true}
              className="name"
              message={me ? "Me" : first_name}
            >
              {me ? "Me" : first_name}
            </ToolTips>
            {/* {CheckValue(showCalories) && showCalories ? <Calories calories={calories_burnt} /> : null} */}
          </div>
        </div>
      )}
    </div>
  );
};

const checkVideoDisplay = (id, isVideoStarted) => {
  const ele = document.getElementById(id);
  if (ele) {
    // console.log('ele.paused',ele.readyState , ele.paused);
    return ele.readyState > 2;
  }
  return false;
};

export const PinVideoView = ({
  pinUserVideo,
  actionPerform,
  required,
  ondemand,
  totalSeconds,
  streamMember,
  memberVideos,
  ...props
}) => {
  const userUI = checkOngoingLimit(pinUserVideo).map((el) => (
    <UserUi
      totalSeconds={totalSeconds}
      setStartStream={(value) => setStartStreamForRecording(el, value)}
      ondemand={ondemand}
      key={el.user_id}
      isVideoStarted={el.video_stream && el.isVideoStarted}
      {...el}
      showPin={false}
      showCalories={
        required.isHeartRateRequired && required.isLeaderBoardRequired
      }
    />
  ));
  const noState = (
    <div className="pin-noState">
      <div className="userPin">
        <SVG src={selectIcon("pinIcon")} />
      </div>
      <p>Pin your friends to see them during the workout</p>
    </div>
  );
  return (
    // <div className='pinVideoView'>
    <HideUnhideDiv
      clasType={`left`}
      clas={`pinVideoView${pinUserVideo.length ? "" : " noState"}`}
    >
      <div
        className={`myStreamVIdeo ${
          memberVideos && memberVideos.getStreamData.isCameraEnabled
            ? "video"
            : "noVideo"
        }`}
      >
        {streamMember}
        <div className="name_calories">
          <span>
            {memberVideos && memberVideos.getStreamData.isCameraEnabled ? (
              "Me"
            ) : (
              <React.Fragment>
                Click on
                <span className="icon_div">
                  <SVG className="scanIcon" src={selectIcon("video")} />
                </span>
                below to see your video here
              </React.Fragment>
            )}
            {/* {memberVideos && memberVideos.getStreamData.isCameraEnabled?'Me':'Click on “this icon” below to see your video here'} */}
          </span>
        </div>
      </div>
      {pinUserVideo.length ? userUI : noState}
    </HideUnhideDiv>
  );
};

export const PinVideoViewZoom = ({
  pinUserVideos,
  zoomData,
  required,
  zoom,
  ...props
}) => {
  const noState = (
    <div className="pin-noState" key={"noState"}>
      <div className="userPin">
        <SVG src={selectIcon("pinIcon")} />
      </div>
      <p>Pin your friends to see them during the workout</p>
    </div>
  );
  const limit = 6;

  const user = checkLimit(pinUserVideos, limit, 0, zoom).map((el) => {
    return <UserUiZoomPinnedView key={el.user_id} {...el} />;
  });
  const hideUnhideCallback = (status) => {
    console.log(status);
    zoom.stopRenderingParticipantsVideos(status);
  };
  return (
    // <div className='pinVideoView'>
    <HideUnhideDiv
      callback={hideUnhideCallback}
      divid="tagged_container_div_zoom"
      clasType={`left`}
      clas={`pin_container_zoom${pinUserVideos.length > 1 ? "" : " noState"}`}
    >
      <canvas
        id="participants-canvas"
        className="video-canvas_ongoing"
        height={CheckValue(zoomData) ? zoomData.height : 400}
        width={CheckValue(zoomData) ? zoomData.width : 200}
      />
      {/* <canvas id="participants-canvas" className='video-canvas_ongoing' height={200} width={217}/> */}
      {user.length > 1 ? user : [user, noState]}
    </HideUnhideDiv>
  );
};

export const PinnedViewZoom = ({ pinUserVideos, required, zoom, ...props }) => {
  const noState = (
    <div className="pin-noState">
      <div className="userPin">
        <SVG src={selectIcon("pinIcon")} />
      </div>
      <p>Pin your friends to see them during the workout</p>
    </div>
  );
  const limit = 6;
  const user = checkLimit(pinUserVideos, limit, 0, zoom).map((el) => {
    return <UserUiZoomPinnedView key={el.user_id} {...el} />;
  });
  const hideUnhideCallback = (status) => {
    zoom.stopRenderingParticipantsVideos(status);
  };
  return (
    <PinnedZoomDiv {...props} callback={hideUnhideCallback}>
      <div id="user_container" className="pinned_user_container">
        <canvas
          id="participants-canvas"
          className="pinned_video-canvas"
        ></canvas>
        {user.length > 1 ? user : [user, noState]}
      </div>
    </PinnedZoomDiv>
  );
};

const PinnedZoomDiv = ({ callback = Function(), ...props }) => {
  return (
    <HideUnhideDiv
      callback={callback}
      divid="tagged_container_div_zoom"
      clasType=""
      clas="zoom_pinned_video_container"
    >
      <div id="member_view_div" className="pinned_member_view_div">
        {props.children}
      </div>
    </HideUnhideDiv>
  );
};

const Calories = ({ calories, ...props }) => (
  <div className="calories">
    {/* <SVG className='calories_svg' src={selectIcon('calories_icon')} /> */}
    <img className="calories_svg" src={selectIcon("calories_icon1")} />
    {/* {calories || '0'} */}
    {calories || "---"}
  </div>
);
const MemberUi = ({
  required,
  ondemand,
  total_attempts_yet,
  showPin,
  rank,
  calories,
  opacity,
  stream,
  showStream,
  userPin,
  first_name,
  me,
  user_status_in_activity,
  max_heart_rate_percent,
  profile_pic_thumb,
  user_id,
  maxHeartRate,
  heartrate,
  video_stream,

  ...props
}) => {
  const userStatus = checkUserStatus(user_status_in_activity, ondemand);
  // if(me) {
  // console.log(me ? 'Me' : first_name,' - ',max_heart_rate_percent);
  // }
  const themeColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--theme-color");
  document.documentElement.style.setProperty(
    "--dynamic-variable",
    themeColor === "light" ? "#505050" : "#000000"
  );
  return (
    <div
      className={`memberUi${me ? " me" : ""}${userStatus ? "" : " disable"}`}
    >
      <div className="memberDetail">
        {/* {required.isHeartRateRequired && required.isLeaderBoardRequired ? <span className='rank'>{rank || ''}</span> : null} */}
        {required.isHeartRateRequired && required.isLeaderBoardRequired ? (
          <span className="rank">{calories && rank ? rank : "---"}</span>
        ) : null}
        <div className="member_picture">
          {/* <CircularProgressbarWithChildren value={heartrate} maxValue={maxHeartRate} strokeWidth={5} styles={{ path: { stroke: "#808080" }, trail: { stroke: me ? '#FFFFFF' : '#ffffff00' } }}> */}
          <CircularProgressbarWithChildren
            value={heartrate}
            maxValue={maxHeartRate}
            strokeWidth={5}
            styles={{
              path: { stroke: textColorSelector(max_heart_rate_percent || 1) },
              trail: { stroke: me ? "#FFFFFF" : "#ffffff00" },
            }}
          >
            <img
              src={
                CheckValue(profile_pic_thumb)
                  ? profile_pic_thumb
                  : selectIcon("userDummy")
              }
              alt="userImage"
              onError={imageError.bind(this)}
            />
          </CircularProgressbarWithChildren>
          {video_stream || stream ? (
            <SVG className="video_icon" src={selectIcon("video_icon")} />
          ) : null}
        </div>
        <div className="name">
          <ToolTips
            overflow={true}
            showTooltip={true}
            message={me ? "Me" : first_name}
          >
            {me ? "Me" : first_name}
          </ToolTips>
          {CheckValue(total_attempts_yet) && total_attempts_yet > 0 ? (
            <span className="attempt">{` x${total_attempts_yet}`}</span>
          ) : null}
        </div>
      </div>
      {showPin ? (
        <div
          className={`userPin${me && !ondemand ? " hide" : ""}${
            showStream ? " active" : ""
          }`}
          onClick={() =>
            userStatus && (ondemand ? true : !me) ? userPin(user_id) : null
          }
        >
          <SVG src={selectIcon("pinIcon")} />
        </div>
      ) : null}
      {required.isHeartRateRequired && required.isLeaderBoardRequired ? (
        <Calories calories={calories} />
      ) : null}
    </div>
  );
};

export const checkUserStatus = (user_status_in_activity, status) =>
  status ||
  user_status_in_activity === "WAITING" ||
  user_status_in_activity === "STARTED";
